import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";

import { UsuariosRepository } from "@shared/Repositories/usuarios.repository";

import { CertificateCoverage } from "@RGVSI/ClientsAndPolicies/Certificates/Types/Interfaces/base-certificate.interface";
import { DetailedPolicy, Policy } from "@RGVSI/Shared/Types/Interfaces/policy.interface";

import { MyPoliciesRepository } from "../Repositories/my-policies.repository";
import { AssociatedPolicy } from "../Types/associated-policy.interface";
import { PolicyCoveragesFilter } from "../Types/policy-coverages-filter.interface";

@Injectable({
  providedIn: "root",
})
export class MyPoliciesService {
  constructor(private userRepository: UsuariosRepository, private myPoliciesRepository: MyPoliciesRepository) {}

  public getMyPolicies({ spinner } = { spinner: true }): Observable<Policy[]> {
    return this.userRepository.getInfoClienteActual().pipe(
      switchMap((user) => {
        const identification = user.identificacion;
        const identificationType = user.tipoIdentificacion.codigoSeguros;
        return this.myPoliciesRepository.getMyPolicies({ identification, identificationTypeCode: identificationType }, spinner);
      })
    );
  }

  public getPolicyDetail(policyIdentification: string): Observable<DetailedPolicy> {
    return this.myPoliciesRepository.getPolicyDetail(policyIdentification);
  }

  public getAssociatedPolicies(): Observable<AssociatedPolicy[]> {
    return this.myPoliciesRepository.getAssociatedPolicies();
  }

  public getPolicyCoverages(filter: PolicyCoveragesFilter): Observable<CertificateCoverage[]> {
    return this.myPoliciesRepository.getPolicyCoverages(filter);
  }
}
